import * as L from 'leaflet';
import { ReactNode, createElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

type MarkerPlacement = 'top' | 'bottom' | 'bottom-right' | 'center';

/** Marker shown on the map when hovering an elevation chart. */
const TRACK_HOVER_MARKER_SIZE: [number, number] = [70, 70];
export const TRACK_HOVER_ICON_FONT_SIZE = 56;
/** Between center (0.5) and bottom-right (1) — keeps the route near the icon feet without a large gap. */
const TRACK_HOVER_ANCHOR_RATIO: [number, number] = [0.62, 0.8];

export const createDivIconMarker = (
  content: ReactNode,
  size: [number, number],
  placement: MarkerPlacement = 'top',
): L.DivIcon => {
  const [width, height] = size;
  const iconAnchor: L.PointExpression =
    placement === 'bottom'
      ? [width / 2, height]
      : placement === 'bottom-right'
        ? [width, height]
      : placement === 'center'
        ? [width / 2, height / 2]
        : [width / 2, 0];

  return L.divIcon({
    html: renderToStaticMarkup(content),
    className: 'leaflet-div-icon-marker',
    iconSize: size,
    iconAnchor,
  });
};

const COMPETITION_DOT_SIZE: [number, number] = [14, 14];

export const createCompetitionDotMarker = (color: string): L.DivIcon =>
  createDivIconMarker(
    createElement('span', {
      style: {
        display: 'block',
        width: 12,
        height: 12,
        borderRadius: '50%',
        backgroundColor: color,
        border: '2px solid #fff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.35)',
      },
    }),
    COMPETITION_DOT_SIZE,
    'center',
  );

export const createTrackHoverMarker = (content: ReactNode): L.DivIcon => {
  const [width, height] = TRACK_HOVER_MARKER_SIZE;
  const [anchorXRatio, anchorYRatio] = TRACK_HOVER_ANCHOR_RATIO;

  return L.divIcon({
    html: renderToStaticMarkup(
      createElement(
        'span',
        {
          style: {
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
          },
        },
        content,
      ),
    ),
    className: 'leaflet-div-icon-marker',
    iconSize: TRACK_HOVER_MARKER_SIZE,
    iconAnchor: [width * anchorXRatio, height * anchorYRatio],
  });
};
